type OrdersIconProps = {
  className?: string;
  fill?: string;
};

export const OrdersIcon = ({
  className,
  fill = "grey-500",
}: OrdersIconProps): React.ReactElement => (
  <svg
    fill={fill}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="22"
    viewBox="0 0 32 22"
  >
    <g
      id="Group_6545"
      data-name="Group 6545"
      transform="translate(10245 22852)"
    >
      <g
        id="Rectangle_1993"
        data-name="Rectangle 1993"
        transform="translate(-10238 -22852)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      >
        <rect width="18" height="7" rx="1" stroke="none" />
        <rect x="0.5" y="0.5" width="17" height="6" rx="0.5" fill="none" />
      </g>
      <g
        id="Rectangle_1994"
        data-name="Rectangle 1994"
        transform="translate(-10245 -22837)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      >
        <rect width="7" height="7" rx="1" stroke="none" />
        <rect x="0.5" y="0.5" width="6" height="6" rx="0.5" fill="none" />
      </g>
      <g
        id="Rectangle_1995"
        data-name="Rectangle 1995"
        transform="translate(-10232 -22837)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      >
        <rect width="7" height="7" rx="1" stroke="none" />
        <rect x="0.5" y="0.5" width="6" height="6" rx="0.5" fill="none" />
      </g>
      <g
        id="Rectangle_1996"
        data-name="Rectangle 1996"
        transform="translate(-10220 -22837)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      >
        <rect width="7" height="7" rx="1" stroke="none" />
        <rect x="0.5" y="0.5" width="6" height="6" rx="0.5" fill="none" />
      </g>
      <line
        id="Line_365"
        data-name="Line 365"
        y2="9"
        transform="translate(-10228.5 -22845.5)"
        fill="none"
        stroke="#fff"
        strokeWidth="1"
      />
      <path
        id="Path_2817"
        data-name="Path 2817"
        d="M-10241.5-22833.5v-8.205h25v8.205"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);
